import { requestCookieConsent } from "./js/cookie-consent.js";
import { start } from "./js/imports.js";

requestCookieConsent(window);

start();
